<template>
    <div>
        <div id="map-img"></div>
        <div id="panel"></div>
    </div>
</template>
  
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { addressList } from "@/api/index";

export default {
    name: 'MyMapComponent',
    data() {
        return {
            map: null,
            map_latitude: 0,
            map_longitude: 0,
        };
    },
    created() {
        this.addressList()
    },
    mounted() {
        this.initMap();
        this.updateMapCenter();
    },
    methods: {
        // 初始化一个地图
        initMap() {
            // AMapLoader.load() 方法加载 AMap JSAPI 相关资源，并传递了一个对象作为参数
            AMapLoader.load({
                key: '5652c5c8815be946ab18b016c25c7bce', // 密钥
                version: '2.0', // 指定要加载的 AMap JSAPI 版本
                plugins: ['AMap.Driving'] //指定需要加载的插件，这里使用了 AMap.Driving 插件，表示需要加载驾车规划功能需要的相关资源
            })
                // 当AMap JSAPI资源加载成功后，在成功的回调当中,将AMap对象作为参数传递给回调函数
                .then((AMap) => {
                    this.map = new AMap.Map('map-img', {
                        resizeEnable: true, //设置地图是否可以调整大小以适应容器
                        center: [this.map_latitude,  this.map_longitude], //设置地图的初始中心点坐标
                        zoom: 13 //设置地图的初始缩放级别
                    });
                });
        },
        async addressList() {
            const {data} = await addressList()
            // console.log(data, 8888);
            // console.log(data.map_latitude, data.map_longitude,156);
            this.map_latitude = data.map_latitude
            this.map_longitude = data.map_longitude
            // 在这里调用更新地图中心点的方法
            this.updateMapCenter();
        },
        updateMapCenter() {
            if (this.map && this.map_latitude && this.map_longitude) {
                this.map.setCenter([parseFloat(this.map_longitude), parseFloat(this.map_latitude)]);
            }
        }
    },
};
</script>
  
<style>
#panel {
    position: fixed;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 10px;
    right: 10px;
    width: 280px;
}

#panel .amap-call {
    background-color: #009cf9;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

#panel .amap-lib-driving {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow: hidden;
}
</style>